export default {
  reprintTitle: 'RFID 补打标签',
  printSetting: '打印机设置',
  macAddressSN: 'Mac地址/序列号',
  printerIP: '打印机IP',
  placehilderIp: '例如：192.168.0.101',
  site: '补标发起方',
  printSettingSuccess: '请求成功，请前往打印机查看。',
  ipFormat: '打印机IP地址格式错误。',
  printerSuccess: '请求成功，请前往打印机查看。',
  clearNextScan: '请先点击"清空"按钮，再继续扫描下一件。',
  back: '返回',
  print: '打印',
  errorcode_435: `无效UPC格式。正确UPC格式应为：00197863493015。`,
  errorcode_436: '调用CPP系统失败，请重试。',
  errorcode_5601: `无效QR Code格式。正确QR Code格式应为： HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1。`,
  errorcode_5602: `QR Code 无效，请扫描产品 UPC，再进行打印操作。`,
  errorcode_5603: '调用产品主数据系统失败，请重试。',
  errorcode_5604: 'QR Code指定UPC与扫描UPC不符。',
  notConnection: '打印机连接失败，请检查网络/打印机连接。',
  errorcode_6001: '打印机连接失败，请检查网络/打印机连接。',
  errorcode_6002: '打印机连接失败，请检查网络/打印机连接。',
  errorcode_6003: '打印机连接错误。',
  errorcode_7008: '该EPC已被产品绑定，请按UPC进行补标。',
  printerIpPlantMismatch: '警告：打印机IP地址与补标仓库编号不符！',
  errorcodeNoInput: '请填入打印机IP地址/补标发起方，再点击确定。',
  placeholderQr: 'QR Code不可输入',
  inputTip: '手动输入后请点击“回车”按键',
  rifdSkuCheck: 'RFID SKU 查询',
  checkTitle: '请扫描产品RFID EPC或者QR Code:',
  checkPlaceholder: '扫描自动识别',
  scanResult: '检测结果',
  division: '产品类别',
  switchToQrCode: '切换 QR Code',
  switchToRfidEpc: '切换 RFID EPC',
  errorcode_check_436: 'Request Error, PLS try again.',
  errorcode_check_8001: '无效数据格式。正确EPC格式应为：30340C13A0436B070931F406。',
  errorcode_check_8002: '无效数据格式。正确QR Code格式应为： HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1。',
  errorcode_check_7004: '此QR Code无法解析出UPC，请扫描EPC查询。',
  errorcode_check_30011: '此EPC无法解析出UPC，请扫描QR Code查询。',
  placehilderTipEpc: '请扫描产品RIFD EPC',
  placehilderTipQrCode: '请扫描产品QR Code',
  settingTip1: `请务必确认打印驱动Zebra Browser
                Print已处于正常运行状态；若尚未完成安装，
                需先行下载并完成安装，随后进入配置界面，
                定位至右下角系统托盘图标，通过右键菜单选择“Settings”选项进行操作。`,
  settingTip2: `配置打印设备时，需录入设备名称及对应的打印机IP地址，
                随后点击“Add”完成设备添加；接着，
                点击“Change”选项，将该设备设为默认打印机。待上述操作完成后，刷新页面，即可生效。`,
  settingTip3: `第一次进入系统需要授权受用。`,
  settingStep1: `第一步`,
  settingStep2: `第二步`,
  settingStep3: `第三步`,
  settingStep4: `第四步`,
  settingDown: `下载地址`,
  settingTour: `设置引导`,
  settingSeeTour: `查看设置引导`
}
